'use client';

import { Divider } from '@mui/material';
import { ROUTES } from '../../../../constants';
import { OutlinedButton, ProjectCard, SwiperSlider } from '../../../components';
import { useTranslations } from 'next-intl';
import { useBreakpoint, useTheme } from '../../../hooks';
import { Project } from '../../../types/Project';
import { LandingPageHeadline } from './components/LandingPageHeadline';
import { LandingPageSection } from './styles';

type Props = {
    projects: Project[];
};

const LandingPageProjectSection = ({ projects }: Props) => {
    const t = useTranslations('landing_page');
    const { colors } = useTheme();
    const breakpoint = useBreakpoint();

    const projectCards = projects.map((project) => (
        <ProjectCard key={project.id} project={project} />
    ));

    return (
        <LandingPageSection breakpoint={breakpoint}>
            <LandingPageHeadline headline={t('projects_title')} description={t('projects_text')} />
            <SwiperSlider
                elements={projectCards}
                slidesPerView={1}
                spaceBetween={24}
            />
            <OutlinedButton
                sx={{ width: 'fit-content', alignSelf: 'center' }}
                label={t('to_projects_button')}
                href={ROUTES.Projects}
            />
            <Divider sx={{ my: 10, borderColor: colors.onPrimaryDark }} />
        </LandingPageSection>
    );
};

export { LandingPageProjectSection };
